import { computed, MaybeRefOrGetter, toValue } from 'vue'
import { Shift } from '../models/shift'

export function useShiftAction(shift: MaybeRefOrGetter<Shift | null>) {
    const can = (action: string) => {
        const value = toValue(shift)
        if (!value) {
            return false
        }

        return value.actions?.includes(action)
    }

    const canEdit = computed(() => can('shift.edit'))
    const canPublish = computed(() => can('shift.publish'))
    const canWork = computed(() => can('shift.work'))

    return {
        canEdit,
        canPublish,
        canWork,
    }
}